import React from 'react'
import classNames from 'classnames'

interface ICrmLoadingIcon {
  className?: string
}

export const CrmLoadingIcon: React.SFC<ICrmLoadingIcon> = ({ className }) => (
  <div className={classNames('LoadingIcon', { className: className })} />
)